import React, { useState } from 'react';
import { Modal, Box, Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TextField } from '@components/atoms';
import { useFormik } from 'formik';
import { CredentialsService } from '@services';
import { DialogConfirm } from '@components/molecules';
import { useSelector } from 'react-redux';
import { date } from 'yup/lib/locale';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const useStyles = makeStyles(theme => ({
  container: {
    [theme.breakpoints.up('sm')]: {
      width: '30%',
    },
    width: '70%',
  },
  submitButton: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(3),
  },
}));

const EcardModal = ({ openModal, setOpenModal, setECardData, formik, addCertificate, eCardDataUpdatedRef, certificateTypesOptions }) => {
  const handleClose = () => setOpenModal(false);
  const [eCardNumber, setEcardNumber] = useState('');
  const [eCardError, setEcardError] = useState('');
  const [ecardAlert, setEcardAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [eCardAlertData, setEcardAlertData] = useState({ title: '', content: '' });
  const classes = useStyles();
  const { user } = useSelector(state => state.user);

  const handleGetEcardDetails = (values) => {
    if (!eCardNumber || eCardError) {
      if (!eCardError) onHandleEcardBlur();
      return;
    }

    setIsLoading(true);
    //CredentialsService.getEcardDetails('1986211', '206504565611', '')
    CredentialsService.getEcardDetails(user.employeeNumber, eCardNumber)
      .then(data => {
        debugger;
        if (data.documentNumber !== null) {
          const alreadyAddedCerts = certificateTypesOptions.filter(v => Number(v.value) === Number(data.certificateID));
          if (!alreadyAddedCerts.length || (!addCertificate && Number(data.certificateID) !== Number(formik.values.certificateID))) {
            setEcardError(`The E-Card information you entered can not be verified, as it is for a different certification type.  Please enter a new E-Card number or enter your certification information manually.`);
            setIsLoading(false);
            return;
          }
          // data.certificateID = certificateID;
          // data.frontImage = [{ original: `data:${data.frontImageType};base64,` + data.frontImage }];
          console.log('new ecard data: ', data);
          setECardData(data);
          setOpenModal(false);
          setIsLoading(false);
          if (!eCardDataUpdatedRef.current) eCardDataUpdatedRef.current = true;
          formik.setFieldValue('certificateID', (data?.certificateID || '').toString());
          formik.setFieldValue('documentNumber', data.documentNumber);
          formik.setFieldValue('agency', data.agency === 'AHA' ? 'American Heart Association' : data.agency);
          formik.setFieldValue('issueDate', data.issueDate);
          formik.setFieldValue('expirationDate', data.expirationDate);
          formik.setFieldValue('activeFlag', data.activeFlag);
          // formik.setFieldValue('employeeCertificatesID', data.employeeCertificatesID);
          if (addCertificate) {
            formik.setFieldValue('frontImage', [{ original: `data:${data.frontImageType};base64,${data.frontImage}` }]);
          } else {
            formik.setFieldValue('certificateImage', [{ original: `data:${data.frontImageType};base64,${data.frontImage}` }]);
          }

        } else {
          setEcardAlert(true);
          setIsLoading(false);
        }
      })
      .catch(e => {
        const error = e.status === 500 ?
          { title: 'The E-Card information you entered can not be verified.', content: 'Please enter a new E-Card number or enter your certification information manually.' } : (e.status === 404 ?
            { title: 'The E-Card information you entered can not be verified, as it does not match the name on file.', content: 'Please enter a new E-Card number or enter your certification information manually.' } :
            { title: 'We can not verify your E-Card at this time.', content: 'Please select Try Again or Cancel to enter your certification information manually.' });
        setEcardAlertData(error);
        setEcardAlert(true);
        setIsLoading(false);
        console.log(e);
      })
  }

  const handleAlertButtons = (openAlert, openEcard) => {
    setEcardAlert(openAlert);
    if (openEcard !== undefined) {
      setOpenModal(openEcard);
    }
  }

  const onHandleEcardChange = (event) => {
    setEcardNumber(event.target.value);
    onHandleEcardBlur();
  }

  const onHandleEcardBlur = () => setEcardError(!eCardNumber ? 'Required' : !/^[0-9]*$/.test(eCardNumber) ? 'Enter correct Ecard number' : '');

  return (
    <div>
      <Modal
        open={openModal}
        onClose={(event, reason) => reason === 'backdropClick'}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className={classes.container}>
          <TextField
            {...{
              name: 'ecardNumber',
              label: 'E-Card Number',
              className: 'center',
              onChange: onHandleEcardChange,
              onBlur: onHandleEcardBlur,
              fullWidth: true,
              required: true,
              value: eCardNumber,
              error: eCardError && Boolean(eCardError),
              helperText: eCardError
            }}
          />
          <div className={classes.submitButton}>
            <Button variant="contained" color="primary" onClick={handleGetEcardDetails}>
              {!isLoading ? 'Submit' : <CircularProgress color="white" size={25} />}
            </Button>
            <Button variant="contained" color="primary" onClick={handleClose}>
              Close
            </Button>
          </div>
        </Box>
      </Modal>
      <DialogConfirm {...{
        dialogProps: {
          open: ecardAlert,
        },
        okBtnText: 'Try Again',
        // title: 'We can not verify your E-Card at this time.',
        // content: 'Please select Try Again or Cancel to enter your certification information manually.',
        ...eCardAlertData,
        onOkClickHandler: () => handleAlertButtons(false),
        onCancelClickHandler: () => handleAlertButtons(false, false)
      }}
      />
    </div >
  )
}

export default EcardModal;
